/**
 * @typedef {Object} Data
 * @property {string} [pageId]
 * @property {string} [sessionId]
 * @property {string} [userHint]
 * @property {string} userId
 */

/**
 * @param {Data} data
 * @returns {void}
 */
const setCustomId = ({
  pageId = null,
  sessionId = null,
  userHint = null,
  userId
}) => {
  if (!userId) return

  if (!window.clarity) {
    setTimeout(() => {
      setCustomId({ userId, sessionId, pageId, userHint })
    }, 250)

    return
  }

  window.clarity('identify', userId, sessionId, pageId, userHint)
}

/**
 * @typedef {Object} Tag
 * @property {string} name
 * @property {string} value
 */

/**
 * @param {Array<Tag>} tags
 * @returns {void}
 */
const setTags = (tags) => {
  if (tags?.length === 0) return

  if (!window.clarity) {
    setTimeout(() => {
      setTags(tags)
    }, 250)

    return
  }

  tags.forEach((tag) => {
    if (tag.name && tag.value) {
      console.log(`%c [Clarity] set - ${tag.name}`, 'color: #6A32A5', tag.value)
      window.clarity('set', tag.name, tag.value)
    }
  })
}

/**
 * @param {String} flag
 * @returns {void}
 */
const setUpgrade = (flag) => {
  if (!flag) return

  if (!window.clarity) {
    setTimeout(() => {
      setUpgrade(flag)
    }, 250)

    return
  }

  window.clarity('upgrade', flag)
}

export default {
  setCustomId,
  setTags,
  setUpgrade
}
